import {
  Paper,
  Typography,
  makeStyles,
  Box,
  Container,
  Button,
  Chip
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Briefcase, Phone, Mail } from 'react-feather';
import Page from 'src/components/Page';
import CustomModal from 'src/components/CustomModal';
import CustomDataTable from '../../components/Table/CustomDataTable';
import {
  deleteAPIAccessKeyAction,
  getAPIAccessKeyAction,
  toggleAPIAccessKeyAction
} from '../../store/actions/AccessKeyActions';
import AccessKeyManager from './components/AccessKeyManager';
import { getClientsAction } from 'src/store/actions/ClientManagerActions';
import FilterAPIAccessKey from './components/FilterAPIAccessKey';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(3),
    textAlign: 'center'
  },
  paperTable: {
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginTop: theme.spacing(2),
    textAlign: 'right'
  },
  otherInfo: {
    display: 'flex',
    justifyContent: 'center',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1)
  },
  datatable: {
    marginTop: theme.spacing(2)
  },
  box: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  userActions: {
    marginTop: theme.spacing(2)
  },
  table: {
    minWidth: 750
    // minHeight: 500
  },
  actionBtn: {
    marginRight: theme.spacing(1)
  }
}));

function APIAccessKey() {
  const profile = JSON.parse(sessionStorage.getItem('profile'));
  const classes = useStyles();
  const dispatch = useDispatch();
  const accessKeyData = useSelector(state => state.AccessKey.accessKeyList);
  const [loading, setLoading] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [modalControl, setModalControl] = useState(false);
  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    setLoading(true);
    async function callAllAPIAccessinfo() {
      const response = await dispatch(getAPIAccessKeyAction('_', profile));
      if (response) {
        setLoading(false);
      }
    }

    dispatch(getClientsAction());
    callAllAPIAccessinfo();
  }, []);

  const handleModalOpen = (e, data) => {
    const currModalID = e.currentTarget.id;
    if (currModalID) setModalControl(currModalID);
    if (data) setModalData(data);
  };

  const closeModal = () => setModalControl(false);

  const tableActions = () => (
    <Box>
      <Button
        id="access-key-mngr"
        variant="contained"
        color="primary"
        onClick={handleModalOpen}
        style={{ marginRight: 10 }}
      >
        Create Access Key
      </Button>
    </Box>
  );

  const tableConfig = [
    {
      title: 'S/N',
      value: 'sn',
      align: 'center',
      render: (row, i) => <> {i + 1} </>
    },
    {
      title: 'Name',
      value: 'name',
      align: 'center'
    },

    {
      title: 'User ID',
      value: 'userID',
      align: 'center'
    },
    {
      title: 'Status',
      value: 'status',
      align: 'center',
      render: (row, i) =>
        row.status == 0 ? (
          <Chip
            variant="outlined"
            color="primary"
            size="small"
            label="Deactivated"
          />
        ) : (
          <Chip
            style={{ background: 'green', color: 'white' }}
            size="small"
            label="Active"
          />
        )
    },
    {
      title: 'Client Name',
      value: 'fullname',
      align: 'center',
      render: (row, i) => <p> {row?.issuer?.fullname || 'None'}</p>
    },
    {
      title: 'Actions',
      value: '',
      align: 'center',
      render: (row, i) => (
        <Box>
          <Button
            id="access-key-mngr"
            className={classes.actionBtn}
            variant="outlined"
            color="primary"
            onClick={e => handleModalOpen(e, row)}
          >
            Update
          </Button>
          <Button
            className={classes.actionBtn}
            variant="outlined"
            color="primary"
            onClick={() => handleToggleStatus(row)}
          >
            {row?.status == 1 ? 'Disable ' : 'Enable '}
          </Button>
          {profile?.super == 1 && (
            <Button
              id="reset-password"
              className={classes.actionBtn}
              variant="outlined"
              color="primary"
              onClick={() => handleDelete(row.id)}
            >
              Delete
            </Button>
          )}
        </Box>
      )
    }
  ];

  const handleDelete = async id => {
    const reset = window.confirm(
      'Are you sure you want to delete this API access key?'
    );
    if (reset) {
      setButtonLoader(true);
      const response = await dispatch(deleteAPIAccessKeyAction(id, profile));
      if (response) setButtonLoader(false);
    }
  };

  const handleToggleStatus = async row => {
    const { id } = row;
    let { status } = row;
    status = status == 1 ? 0 : 1;
    const toggle = window.confirm(
      'Are you sure you want to toggle this staff status?'
    );
    if (toggle) {
      setButtonLoader(true);
      const response = await dispatch(
        toggleAPIAccessKeyAction(id, { status }, profile)
      );
      if (response) setButtonLoader(false);
    }
  };

  return (
    <Page className={classes.root} title="API Access Key">
      <Container maxWidth="lg">
        <Box>
          <FilterAPIAccessKey />
        </Box>
        <Box className={classes.datatable}>
          <CustomDataTable
            className={classes}
            tableData={accessKeyData}
            tableConfig={tableConfig}
            tableActions={tableActions}
            loading={loading}
            filterField="name"
          />
        </Box>
      </Container>

      {/* Modals */}
      <CustomModal
        open={modalControl === 'access-key-mngr'}
        handleClose={closeModal}
        title="Manage Access Key"
      >
        <AccessKeyManager handleClose={closeModal} modalData={modalData} />
      </CustomModal>
    </Page>
  );
}

export default APIAccessKey;
